module.exports = __webpack_public_path__ + "static/media/tour.97827052.svg";